<template>
  <div class="coursetype flex ">
    <div class="sidebar">
      <van-sidebar v-model="activeKey">
        <van-sidebar-item title="标签名称" />
        <van-sidebar-item title="标签名称" />
        <van-sidebar-item title="标签名称" />
      </van-sidebar>
    </div>

    <div class="rightside">
      <div v-for="i in 6 " :key="i" class="h58">
        <div class="typebtn " >健康保险健康保险</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Sidebar, SidebarItem } from "vant";

Vue.use(Sidebar);
Vue.use(SidebarItem);
export default {
  data() {
    return {
      activeKey: 0,
    };
  },
};
</script>

<style lang="less" scoped>
.coursetype {
  width: 100%;
  background: #fff;
  align-items: flex-start;
  .sidebar {
    width: 115px;
    height: 100vh;
    overflow-y: auto;
    line-height: 23px;
    background-color: rgba(237, 241, 244, 100);
    color: rgba(48, 91, 119, 100);
    font-size: 16px;
    text-align: center;
    font-family: -apple-system;
    .van-sidebar {
      width: 100%;
    }
    .van-sidebar-item {
      background: transparent;
    }
    .van-sidebar-item--select,
    .van-sidebar-item--select:active {
      background-color: #fff;
    }
    .van-sidebar-item--select::before{
        width: 4px;
        height: 20px;
        background: rgb(238, 10, 36);
    }
  }
  .rightside {
    width: 260px;
    display: flex;
    flex-wrap: wrap;
    .typebtn {
    //   width: 90px;
      max-width: 100px;
      height: 38px;
      line-height: 38px;
      border-radius: 50px;
      background-color: rgba(237, 241, 244, 100);
      color: rgba(48, 91, 119, 100);
      font-size: 16px;
      text-align: center;
      font-family: PingFang SC;
      border: 1px solid rgba(255, 255, 255, 100);
      margin-top: 20px;
      margin-left: 20px;
      overflow: hidden;
      padding: 0 5px;
    }
    .h58{
        height: 58px;
    }
  }
}
</style>